var render, staticRenderFns
import script from "./CardList.vue?vue&type=script&lang=tsx&"
export * from "./CardList.vue?vue&type=script&lang=tsx&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=becd9526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becd9526",
  null
  
)

export default component.exports